import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  general: drilldownData["general"].map(({ fieldName, placeholder, name, formType, validation, className, note }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    note: note
  })),
  circular: drilldownData["circular"].map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, note }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType,
    note: note
  })),
};
